export { ApiInterface } from './api.service';
export { ApiService } from './api.service';
export { ApiCollection } from './collection';
export { Model } from './model';



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/api/index.ts